/**
 * Alpine.js component for the Vantage Comparison Selector
 *
 * Manages the UI state for selecting and managing comparisons,
 * including expand/collapse state for inline filter editing.
 */
export default () => ({
    /**
     * Track which comparison is currently expanded for filter editing
     */
    expandedComparisonId: null,

    /**
     * Initialization
     */
    init() {
        // Listen for comparison events from Livewire
        this.$wire.on('comparisonAdded', (data) => {
            this.handleComparisonAdded(data);
        });

        this.$wire.on('comparisonRemoved', () => {
            this.handleComparisonRemoved();
        });

        this.$wire.on('comparisonUpdated', () => {
            this.handleComparisonUpdated();
        });

        this.$wire.on('comparisonsCleared', () => {
            this.handleComparisonsCleared();
        });
    },

    /**
     * Toggle expand/collapse state for a comparison
     */
    toggleExpand(comparisonId) {
        this.expandedComparisonId = this.expandedComparisonId === comparisonId
            ? null
            : comparisonId;
    },

    /**
     * Check if a specific comparison is expanded
     */
    isExpanded(comparisonId) {
        return this.expandedComparisonId === comparisonId;
    },

    /**
     * Collapse all expanded comparisons
     */
    collapseAll() {
        this.expandedComparisonId = null;
    },

    /**
     * Handle comparison added event
     */
    handleComparisonAdded(data) {
        // Auto-expand newly added custom comparisons for immediate editing
        if (data && data.comparisonId && data.type === 'custom') {
            this.$nextTick(() => {
                this.expandedComparisonId = data.comparisonId;
            });
        }
    },

    /**
     * Handle comparison removed event
     */
    handleComparisonRemoved() {
        // Clear expanded state if the removed comparison was expanded
        this.expandedComparisonId = null;
    },

    /**
     * Handle comparison updated event
     */
    handleComparisonUpdated() {
        // Keep current expand state - no action needed
    },

    /**
     * Handle all comparisons cleared event
     */
    handleComparisonsCleared() {
        this.expandedComparisonId = null;
    },
});
